export default "__VITE_ASSET__BBDKz4Rm__"